export default __webpack_public_path__ + "media/images/services/service-06-370x250-514bd020cbceb53e3aa8404088b32182.jpg";